// 计费单

import { HttpGetInventorySnapshot, HttpGetInventorySnapshotExport,HttpGetProduct } from '@/service/inventory';
import TableList from "@components/templates/tablelist";
import mixin from "../mixin";
import { mapGetters } from 'vuex';
export default {
    mixins: [TableList, mixin],
    data() {
        return {
            isMixin: true,
            Tools: { show: true },
            Tabs: { show: true },
            formData: {},
            products:[],
            Searchs: {
                show: true,
                labelWidth: 110,
            },
            Plugins: { show: true },
        };
    },
    watch:{
        "$route":function (to,from) {
            this.$set(this.formData,"search[EQ_organizationId]",this.isAdmin() ? '' : global.SYSID)
            this.updateList();
        }
    },
    methods: {
        ajaxRequest: HttpGetInventorySnapshot,
        interceptResponse(params){
            if(params.content.length>0){
                let productIds = [];
                params.content.forEach(item => {
                    productIds.push(item.productId);
                  });
                HttpGetProduct({
                    contextId: global.SYSID,
                    productIds:productIds
                  })
                    .then(res => {
                        this.products = res.data;
                    })
                    .catch(err => {
                      this.$VMessage.error(err.message);
                    });
            }
            
        },
        interceptRequest(params) {
            params.state = this.isAdmin() ? '1' : '0';
            this.formData.state = params.state;
            return params
            
        },
        handleOperates(params , type, batch) {
            
            switch (type) {
                case 'export':
                    var param =JSON.stringify(this.formData.search);
                    if(this.isAdmin()){
                        var url = process.env.VUE_APP_BI + '/home/report/board?id=154&params='+param;
                        window.open(url, '_blank');

                    }else{
                        var url = process.env.VUE_APP_BI + '/home/report/board?id=177&params='+param;
                        window.open(url, '_blank');

                    }
                    break;
            }
        },
        isAdmin() {
            return this.$route.name === 'inventorySerSnapshot';
        },
    },
    computed: {
        ...mapGetters('dictionary', ['getProductList', 'getSelfmanageorgList','getBillcusorgList', 'getCusproductList', 'getSystemWareList','getAdminTransferWarehouse', 'getTransferWarehouse','getBillcusWareList','getManageAccountList','getOrgAccountList']),
        // ...mapGetters('common', ['getProductType', 'getInventoryType', 'getInventorySnapshotType']),
        ToolsData() {
            return [
                {
                    name: this.$t('global.common.export', { defaultValue: "导出" }),
                    show: this.handleAuth('fbb.inventorysnapshot.export'),
                    operate: "export",
                    theme: "info",
                },
            ]
        },
        SearchsData() {
            return [
                {
                    label: this.$t('bi.work.task_org_id', { defaultValue: "组织" }),
                    key: 'EQ_organizationId',
                    more: true,
                    tag: 'vSelect',
                    options: this.getBillcusorgList,
                    hidden: !this.isAdmin(),
                    props: {
                        filterable: true,
                    },
                },
                {
                    label: this.$t('erp.b2c.product_orgwarehouse', { defaultValue: "仓库" }),
                    key: 'IN_orgWarehouseCode',
                    show: true,
                    tag: 'vSelect',
                    options: (this.isAdmin() ? this.getAdminTransferWarehouse : this.getTransferWarehouse).map(function (item = "") {
                        return { value: item.attach.code, label: item.label };
                    }),
                    props: {
                        filterable: true,
                        multiple: true,
                    },
                    style: "width:250px",
                },
                {
                    label: this.$t('bi.work.task_account_id', { defaultValue: "渠道" }),
                    key: 'IN_sourceChannel',
                    more: true,
                    tag: 'vSelect',
                    options: this.isAdmin() ? this.getManageAccountList : this.getOrgAccountList,
                    props: {
                        filterable: true,
                        multiple: true,
                    },
                    style: "width:250px",
                },
                {
                    label: this.$t('global.common.project', { defaultValue: "项目" }),
                    key: 'IN_groupCode',
                    more: true,
                    tag: 'vSelect',
                    options: this.isAdmin() ? this.getCusproductList : this.getProductList,
                    props: {
                        filterable: true,
                        multiple: true,
                    },
                    style: "width:250px",
                },
                {
                    label: "SKU",
                    key: 'RCN_sku',
                    show: true,
                    tag: 'vInput',
                },
                {
                    label: this.$t('erp.setting.goods_type', { defaultValue: "产品类型" }),
                    key: 'EQ_productType',
                    more: true,
                    tag: 'vSelect',
                    options: this.getProductType,
                    props: {
                        filterable: true,
                    },
                },
                {
                    label: this.$t('fbb.inbound.inventory_type', { defaultValue: "库存类型" }),
                    key: 'EQ_inventoryType',
                    more: true,
                    tag: 'vSelect',
                    options: this.getInventorySnapshotType,
                    props: {
                        filterable: true,
                    },
                },
                {
                    label: this.$t('fbb.inventory.snap_shot_date', { defaultValue: "库存快照日期" }),
                    tag: 'vDatepicker',
                    key: 'BT_fetchDate',
                    show: true,
                    default: this.handleDateRange().join(' ~ '),
                    props: {
                        options: this.options,
                        format: 'yyyy-mm-dd ~ yyyy-mm-dd',
                        confirm: false,
                    },
                    style: "width:250px",
                },

            ]
        },
        columns() {
            return [
                {
                    title: this.$t('fbb.alloment.client_organization', { defaultValue: '客户' }),
                    key: 'organizationId',
                    width: this.isAdmin() ? 100 : 0,
                    render: (h, { row }) => {
                        let orgName = this.getSelfmanageorgList.filter(item => {
                            return item.value === row.organizationId
                        })[0] || {}
                        return orgName.label
                    }
                },
                {
                    title: this.$t('erp.b2c.product_orgwarehouse', { defaultValue: '仓库' }),
                    maxWidth: 200,
                    render: (h, { row }) => {
                        let orgWarehouseCode = row.orgWarehouseCode
                        const { label } = (this.isAdmin() ? this.getAdminTransferWarehouse : this.getTransferWarehouse).find(function (item) {
                            return item.attach.code == orgWarehouseCode
                        }) || {};
                        return <div>{label}</div>
                    }
                },
                {
                    title: this.$t('bi.work.task_account_id', { defaultValue: '渠道' }),
                    key: 'sourceChannel',
                },
                {
                    title: this.$t('global.common.project', { defaultValue: '项目' }),
                    render: (h, { row }) =>
                        this.findRenderLabel(
                            this.isAdmin() ? this.getCusproductList : this.getProductList,
                            row.groupCode
                        )
                },
                {
                    title: 'SKU',
                    key: 'sku',
                },
                {
                    title: this.$t('erp.setting.goods_type', { defaultValue: '产品类型' }),
                    maxWidth: 80,
                    render: (h, { row }) => {
                        let productType = row.productType
                        const { label } = this.getProductType.find(function (item) {
                            return item.value == productType
                        }) || {};
                        return <div>{label}</div>
                    }
                },
                {
                    title: this.$t('fbb.inbound.inventory_type', { defaultValue: '库存类型' }),
                    maxWidth: 80,
                    key: 'inventoryType',
                    render: (h, { row }) => {
                        let inventoryType = row.inventoryType
                        const { label } = this.getInventorySnapshotType.find(function (item) {
                            return item.value == inventoryType
                        }) || {};
                        return <div>{label}</div>
                    }
                },
                {
                    title: this.$t('fbb.alloment.inventory_available', { defaultValue: '可用库存' }),
                    key: 'inventoryAvailable',
                },
                {
                    title: this.$t('erp.product.reserved', { defaultValue: '预留' }),
                    key: 'inventoryReserved',
                },
                {
                    title: this.$t('erp.product.transport', { defaultValue: '在途' }),
                    key: 'inventoryTransport',
                },
                {
                    title: this.$t('fbb.inventory.total_stock', { defaultValue: '仓库总库存' }),
                    key: 'inventoryCurrent',
                },
                // {
                //     title: this.$t('fbb.inventory.product_value', { defaultValue: '产品价值' }),
                //     key: 'fobCost',
                // },
                // {
                //     title: this.$t('erp.product_channel.currency', { defaultValue: '币种' }),
                //     key: 'inventoryCurrency',
                // },
                {
                    title: `${this.$t('fbb.accountmanage.material_size_length', { defaultValue: '长' })}*${this.$t('fbb.accountmanage.material_size_width', { defaultValue: '宽' })}*${this.$t('fbb.accountmanage.material_size_height', { defaultValue: '高' })}(cm)`,
                    key: 'weight',
                    render: (h, { row }) => {
                        var product = this.products.filter(
                            item => {
                              return item.id == row.productId;
                            }
                          )[0]
                          if(product){
                            var Length = product.length;
                            var Width =  product.width;
                            var Height =  product.height;
                            return <div>{Length}*{Width}*{Height}</div>
                          }
                       
                    }
                },
                {
                    title: this.$t('global.common.weight(g)', { defaultValue: '重量(g)' }),
                    key: 'weight',
                    render: (h, { row }) => {
                        var product = this.products.filter(
                            item => {
                              return item.id == row.productId;
                            }
                          )[0]
                          if(product){
                            var weight2 = product.weight
                            return <div>{weight2}</div>
                          }
                        
                        
                    }
                },
                {
                    title: this.$t('fbb.inventory.stock_update_date', { defaultValue: '库存更新时间' }),
                    key: 'operateAt',
                },
                {
                    title: this.$t('fbb.inventory.snap_shot_date', { defaultValue: '库存快照日期' }),
                    key: 'fetchDate',
                },
                {
                    title: this.$t('fbb.inventory.system_catch_date', { defaultValue: '系统抓取时间' }),
                    width: 150,
                    key: 'fetchAt',
                },
            ];
        },
    },
};




